export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="footer" className="bg-background-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-20">
          <div className="lg:max-w-sm">
            <a href="#hero" className="inline-block mb-4 no-underline">
              <span className="text-2xl font-bold font-heading text-background-50">
                <span className="text-primary-400">58</span>影院
              </span>
            </a>
            <p className="text-sm text-background-300 leading-relaxed">
              58影院致力于为广大剧迷提供最新、最全的电视剧免费在线观看服务。每日同步更新热门电视剧，高清流畅画质，免注册免会员，全集一次看完。追剧不等待，尽在58影院。
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 gap-8 flex-1">
            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4 font-heading">快速导航</h4>
              <ul className="space-y-2">
                {[
                  { label: '热播榜单', href: '#ranking' },
                  { label: '热门话题', href: '#topics' },
                  { label: '观众热评', href: '#comments' },
                  { label: '常见问题', href: '#faq' },
                ].map((item) => (
                  <li key={item.href}>
                    <a
                      href={item.href}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 no-underline cursor-pointer"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4 font-heading">剧集分类</h4>
              <ul className="space-y-2">
                {['国产剧', '韩剧', '美剧', '日剧', '泰剧'].map((cat) => (
                  <li key={cat}>
                    <a href="#index" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 no-underline cursor-pointer">{cat}</a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4 font-heading">合作伙伴</h4>
              <p className="text-sm text-background-400 leading-relaxed">
                更多合作伙伴信息即将上线，敬请期待。
              </p>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {currentYear} 58影院 - 本站内容仅供学习交流，请支持正版。
          </p>
          <p className="text-xs text-background-500">
            本站为非盈利性网站，所有电视剧资源均来自互联网分享。
          </p>
        </div>
      </div>
    </footer>
  );
}